import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaSeparated',
    standalone: false
})
export class CommaSeparatedPipe implements PipeTransform {

  transform(value: Set<string>): string {
    if (!value) {
      return '';
    }

    return Array.from(value).join(', ');
  }

}
